module.exports = __webpack_public_path__ + "static/img/gsxinwen.53292592.jpg";